import Vue from 'vue';

import FilterEnum from './enum';
import FilterRange from './range';
import FilterString from './string';
import FilterMToggle from './m-toggle';
import FilterColor from './color';
import FilterCheckbox from './checkbox';

const filters = {
    'multiple': {
        name: 'filter-enum',
        component: FilterEnum,
    },
    'range': {
        name: 'filter-range',
        component: FilterRange,
    },
    'string': {
        name: 'filter-string',
        component: FilterString,
    },
    'm-toggle': {
        name: 'filter-mtoggle',
        component: FilterMToggle,
    },
    'colors': {
        name: 'filter-color',
        component: FilterColor,
    },
    'checkbox': {
        name: 'filter-checkbox',
        component: FilterCheckbox,
    },
};

Object.values(filters)
    .forEach(({ name, component }) => Vue.component(name, component));

export const resolveFilterComponent = type => {
    if (filters[type]) {
        return filters[type].name || 'filter-string';
    }
    return 'filter-string';
};